"use client";

import {
  Menubar,
  MenubarContent,
  MenubarMenu,
  MenubarTrigger,
} from "@oreme/ui";
import {
  SharedMenubarViewTile,
  SharedMenubarViewProjection,
  SharedMenubarViewZoom,
  SharedMenubarSettingsLocale,
  SharedMenubarSettingsTheme,
  SharedMenubarViewSidebar,
} from "@/components";
import { useAtom } from "jotai";
import { aboutPanelVisibilityAtom } from "@/store";
import { useTranslations } from "next-intl";

function SharedMenubar() {
  const t = useTranslations("global.Menubar");
  const [about, toggleAbout] = useAtom(aboutPanelVisibilityAtom);

  const handleAbout = () => {
    toggleAbout();
  };

  return (
    <Menubar className="border-0 ml-auto lg:ml-0">
      <MenubarMenu>
        <MenubarTrigger className="hidden lg:flex">{t("view")}</MenubarTrigger>
        <MenubarContent>
          <SharedMenubarViewSidebar />
          <SharedMenubarViewTile />
          <SharedMenubarViewProjection />
          <SharedMenubarViewZoom />
        </MenubarContent>
      </MenubarMenu>
      <MenubarMenu>
        <MenubarTrigger className="hidden lg:flex">
          {t("settings")}
        </MenubarTrigger>
        <MenubarContent>
          <SharedMenubarSettingsLocale />
          <SharedMenubarSettingsTheme />
        </MenubarContent>
      </MenubarMenu>
      <MenubarMenu>
        <MenubarTrigger
          onClick={handleAbout}
          data-state={about ? "open" : "closed"}
        >
          {t("about")}
        </MenubarTrigger>
      </MenubarMenu>
    </Menubar>
  );
}

export { SharedMenubar };
